import React, { createElement } from 'react'
import moduleCss from './index.module.scss'

export interface TitleProps {
    nodeId?: string
    style?: object // 容器样式

    height?: number // 组件高度
    image?: string // 背景图

    text?: string // 文本
    textStyle?: object // 文本样式
    isTextHasIcon?: boolean // 文本前方是否有图片
    textIcon?: string // 文本前方的图片
    textIconHeightFull?: boolean // 文本前方的图片高度 100%?
    textAlign?: string // 文本位置

    isHasAddonAfter?: boolean // 是否添加额外的元素
    isHasAddonAfterIcon?: boolean // 额外元素是否有图片
    addonAfterIcon?: string // 额外元素的图片
    addonAfterIconHeightFull?: boolean // 额外元素图片高度 100%？
    addonAfterText?: string // 额外元素的文本
    addonAfterTextStyle?: object // 额外文本的样式
    addAfterHref?: string // 额外元素的跳转链接
}

const Title: React.FC<TitleProps> = (props) => {
    const { nodeId, style,
        height, image,
        text, textStyle, isTextHasIcon, textIcon, textAlign, textIconHeightFull,
        isHasAddonAfter, isHasAddonAfterIcon, addonAfterIcon, addonAfterText, addonAfterTextStyle, addAfterHref, addonAfterIconHeightFull
    } = props

    return (
        <div id={nodeId} className={moduleCss.title} style={{ backgroundImage: `url("${image}")`, height: `${height}px`, ...style }}>
            <div className={moduleCss.textPart} style={{  justifyContent: textAlign, ...textStyle }}>
                {
                    isTextHasIcon && <img src={textIcon} style={{ marginRight: '6px', height: textIconHeightFull ? '100%' : 'auto' }} alt="" />
                }
                <div>
                    {text}
                </div>
            </div>
            {
                isHasAddonAfter &&
                <a className={moduleCss.addonAfter} href={addAfterHref} target="_blank">
                    {
                        isHasAddonAfterIcon && <img src={addonAfterIcon} style={{ marginRight: '6px', height: addonAfterIconHeightFull ? '100%' : 'auto' }} alt="" />
                    }
                    <span style={addonAfterTextStyle}>
                        {addonAfterText}
                    </span>
                </a>
            }
        </div>
    )
}

export default Title
